/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events on document so header cart count and
 *   cart drawer listeners (both scoped to `document`) receive them.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 *
 * FIX 2026-07-11: eventTarget was previously scoped to
 * `theme-drawer#cart-drawer`, which meant the cartLinesUpdate event never
 * reached the document-level listeners in cart-icon.js (header bubble) and
 * cart-drawer.js's own handler. Items were still added to the cart
 * correctly, but the header cart count never updated, making Add to Cart
 * look broken to shoppers. Reverting eventTarget to document fixes this.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
